import { useCallback, useEffect, useState } from "react";

export function useAccordionList({
    allowMultiple = false, // if true, multiple accordions can be expanded at once
    initialExpanded = [],
}: {
    allowMultiple?: boolean;
    initialExpanded?: string[];
}) {
    const [expanded, setExpanded] = useState<string[]>(initialExpanded);

    useEffect(() => {
        setExpanded(initialExpanded);
    }, [initialExpanded]);

    const onClick = useCallback(
        (i: string) => {
            if (allowMultiple) {
                if (!expanded.includes(i)) {
                    setExpanded((prev) => [...prev, i]);
                } else {
                    setExpanded((prev) => prev.filter((id) => id !== i));
                }
            } else {
                if (expanded.includes(i)) {
                    setExpanded([]);
                } else {
                    setExpanded([i]);
                }
            }
        },
        [allowMultiple, expanded, setExpanded],
    );

    return { expanded, setExpanded, onClick };
}
